import { isDevice } from "../../utils/isDevice";

export class ModalAngelopolis {
  constructor() {
    if (ModalAngelopolis.instance) {
      return ModalAngelopolis.instance;
    }
    ModalAngelopolis.instance = this;

    this.htmlElement = document.querySelector("#modalAngelopolis");
    this.closeIconZoneModal = document.querySelector(
      "#iconCloseZoneInfoModalAngelopolis"
    );
    this.eventListenners();

    if (isDevice()) {
      this.htmlElement.style.display = "none";
    }
  }

  showModal() {
    if (this.htmlElement.classList.contains("hidden")) {
      this.htmlElement.classList.replace("hidden", "flex");
    }
  }

  hideModal() {
    if (this.htmlElement.classList.contains("flex")) {
      this.htmlElement.classList.replace("flex", "hidden");
    }
  }

  eventListenners() {
    this.closeIconZoneModal.addEventListener("click", () => {
      // console.log("click");
      this.hideModal();
    });
  }
}
